export const docsInfoDefaultContent = {info: 'INFO1', component: 'Info1'};
export const docsInfoSidebarConfig = [
  {
    title: 'API Overview',
    component: 'Info4',
    items: [
      { display: 'Getting Started', component: 'Info1' },
      {
        display: 'Authorization',
        component: 'Info2',
        subItems: [
          { display: 'Client Credentials Flow', component: 'Info6' },
          { display: 'Password Flow', component: 'Info7' },
          { display: 'Authorization Code Flow', component: 'Info8' },
          { display: 'Authorization Id Flow', component: 'Info9' }
        ]
      },
      { display: 'API Usage', component: 'Info3',
        subItems: [
          { display: 'OTP Handling', component: 'Info10' },
          { display: 'Signing', component: 'Info11' }
        ]
      },
      { display: 'Postman Collection', component: 'Info5' }
    ]
  }
];
export const docsInfoDynamicContentScreen = 'ApiInfo';
